<!--
/**
 * @name 'index'
 * @desc ''
 * @author ''
 * @time 2022年05月10日 15:47:35 星期二
 */
-->
<template>
  <div class="borx">
    <div class="home flex-col">
      <!-- 头部 -->
      <div class="home-head">
        <img src="../../assets/home/head_bg.png" class="head-bg">
        <div class="home-head-text">
          {{title}}
        </div>
        <div class="timeStamp">
          <span> {{ nowTime }}</span>
          <span> {{ hh }} </span>
          <span style="margin-left: 10px;">{{ getWeek }}</span>
        </div>
        <div class="signout">
          <router-link :to="{path: '/guide/personal'}"><i class="el-icon-switch-button"></i></router-link>
        </div>
      </div>

      <div class="flex-1 home-content flex-box">
        <!-- 左框框 -->
        <div class="home-Left flex-col">
          <div class="home-Left0">
            <!-- <frame title="服务项目统计"></frame>
            <div class="frame-0" id="frame-0-echarts"></div>
            -->
            <frame title="最新服务记录"></frame>
            <div class="new-list">
              <leftTopSwiper :list='serviceData.service_record_week' v-if="serviceData && serviceData.service_record_week.length"></leftTopSwiper>
              <div v-else style="text-align: center;color: #999;font-size: 13px;line-height: 100px;">暂无记录</div>
            </div>

          </div>


          <div class="home-Left1">
            <frame title="服务对象服务统计"></frame>
            <div class="frame-1" id="frame-1-echarts"></div>
          </div>
        </div>

        <!-- 中框框 -->
        <div class="home-in flex-1 flex-col">
          <div class="home-in-top flex-sa">
            <img src="../../assets/home/border.png" class="border-top">
            <img src="../../assets/home/border.png" class="border-bottom">
            <div>
              <div class="num">{{ serviceData.service_log_to_day || 0 }}</div>
              <div class="name">今日服务</div>
            </div>

            <div>
              <div class="num">{{ serviceData.service_log_all || 0 }}</div>
              <div class="name">累计服务</div>
            </div>
            <div>
              <div class="num">{{ serviceData.service_customer_all || 0 }}</div>
              <div class="name">累计服务对象</div>
            </div>
            <div>
              <div class="num">{{ serviceData.service_log_to_month || 0 }}</div>
              <div class="name">本月服务</div>
            </div>
            <div>
              <div class="num">{{ serviceData.pre_audit_qualified_month || 0 }}</div>
              <div class="name">本月预审合格</div>
            </div>
            <div>
              <div class="num">{{ serviceData.no_service_customer_month || 0 }}</div>
              <div class="name">本月未服务</div>
            </div>
          </div>

          <div class="home-in-bottom">
            <div id="container" class="home-in-chart"></div>
            <div class="service-count">
              <div class="flex-fs">
                <div class="tag" style="background: #FDAE02;"></div>
                <span class="tag-name">服务对象分布</span>
              </div>
              <div class="flex-fs">
                <div class="tag"></div>
                <span class="tag-name">服务中服务对象</span>
                <!-- <span>{{ serviceData.service_log_ing_total || 0 }}</span> -->
              </div>
            </div>
          </div>
        </div>

        <!-- 右框框 -->
        <div class="home-right flex-col">
          <div class="home-right1">
            <frame title="服务对象信息统计"></frame>
            <div class="frame-1" id="frame-right1-echarts"></div>
          </div>
          <div class="home-right2">
            <frame title="服务评价统计"></frame>
            <div class="frame-2 flex-col">
              <div class="flex-fs count-box">
                <div class="box">
                  <div class="n">{{ commentTotal }}</div>
                  <span class="u">条</span>
                </div>
                <p>累计评价统计</p>
              </div>
              <!-- <div id="frame-right2-echarts" class="flex-1" style="width: 100%;"></div> -->
              <div class="flex-1 star-box">
                <div class="flex-fs" v-for="(item,i) in commentList" :key="i">
                  <img src="../../assets/home/star-1.png" v-if="i==4">
                  <img src="../../assets/home/star-2.png" v-if="i==3">
                  <img src="../../assets/home/star-3.png" v-if="i==2">
                  <img src="../../assets/home/star-4.png" v-if="i==1">
                  <img src="../../assets/home/star-5.png" v-if="i==0">
                  <span>{{ item.name }}</span>
                  <el-progress :color='i%2==0?"#099BCC":"#097ECC"' define-back-color='#0A337E' :percentage="(item.value/commentTotal)*100" class="flex-1" :stroke-width="7"
                    :show-text='false'></el-progress>
                  <a>{{ item.value }}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Notice></Notice>
    </div>
  </div>
</template>

<script>
  import userInfoAPI from '@/api/dashboard'
  import frame from '../../components/frame.vue';
  import leftTopSwiper from './components/left-top-swiper';
  import Notice from '@/components/Notice.vue';
  import * as echarts from 'echarts';
  import marker from '../../assets/home/marker.png'
  import markerc from '../../assets/home/markerc.png'
  import marker_active from '../../assets/home/marker-active.png'


  import titleBg from '../../assets/home/title-bg.png'
  import corner from '../../assets/home/jiao.png'
  import marker_line from '../../assets/home/line.png'
  import AMapLoader from '@amap/amap-jsapi-loader';
  import config from '@/config/index'
  var that,
    myChart,
    myChart1,
    myChart2,
    myChart3
  export default {
    name: 'index',
    components: {
      frame,
      Notice,
      leftTopSwiper
    },
    props: {},
    data() {
      return {
        title: config.txt.title,
        nowTime: "",
        getWeek: '',
        hh: '',
        num: '',
        serviceData: '',

        map: null,
        marker: marker,
        marker_active: marker_active,
        markerc: markerc,
        corner: corner,
        marker_line: marker_line,
        titleBg: titleBg,
        commentList: []
      }
    },
    watch: {},
    destroyed() {
      this.map && this.map.destroy();
      console.log("地图已销毁");
      clearTimeout(that.num);
    },
    created() {},
    mounted() {
      that = this;
      that.init();
      that.initData();
      that.showTimes();
    },
    beforeDestroy() {

    },
    computed: {
      commentTotal() {
        let sum = 0
        this.commentList.forEach(i => {
          sum += i.value
        })
        return sum
      }
    },
    methods: {
      timeFormate(timeStamp) {
        let year = new Date(timeStamp).getFullYear();
        let month =
          new Date(timeStamp).getMonth() + 1 < 10 ?
          "0" + (new Date(timeStamp).getMonth() + 1) :
          new Date(timeStamp).getMonth() + 1;
        let date =
          new Date(timeStamp).getDate() < 10 ?
          "0" + new Date(timeStamp).getDate() :
          new Date(timeStamp).getDate();
        let hh =
          new Date(timeStamp).getHours() < 10 ?
          "0" + new Date(timeStamp).getHours() :
          new Date(timeStamp).getHours();
        let mm =
          new Date(timeStamp).getMinutes() < 10 ?
          "0" + new Date(timeStamp).getMinutes() :
          new Date(timeStamp).getMinutes();
        let ss =
          new Date(timeStamp).getSeconds() < 10 ?
          "0" + new Date(timeStamp).getSeconds() :
          new Date(timeStamp).getSeconds();
        let week = new Date(timeStamp).getDay();
        let weeks = ["日", "一", "二", "三", "四", "五", "六"];
        let getWeek = "星期" + weeks[week];
        that.nowTime =
          year +
          "." +
          month +
          "." +
          date;
        that.getWeek = getWeek;
        that.hh = hh + ":" + mm
      },

      showTimes() {
        that.timeFormate(new Date());
        that.num = setTimeout(that.showTimes, 1000);
      },

      init() {
        window.addEventListener("resize", () => {
          setTimeout(() => {
            myChart.resize();
            myChart1.resize();
            myChart2.resize();
            // myChart3.resize();
          }, 500)
        })
      },
      initGaoDeMap() {
        AMapLoader.load({
          key: "859fb31aceab901ea62f078b5bb026d8",
          version: "2.0",
          plugins: ['AMap.DistrictSearch'],
          securityJsCode: '68da1857ca3142e1b473e728973e3670'
        }).then((AMap) => {
          var options = {
            subdistrict: 0,
            extensions: 'all',
            level: 'province'
          };
          var district = new AMap.DistrictSearch(options);
          district.search('江津区', function(status, result) {
            var bounds = result.districtList[0]['boundaries'];
            var mask = [];
            for (var i = 0; i < bounds.length; i++) {
              mask.push([bounds[i]]);
            }
            //实例化地图
            that.map = new AMap.Map("container", {
              mask: mask,
              zoom: 10.8,
              expandZoomRange: true,
              zooms: [3, 128],
              center: [106.281781, 29.091010],
              viewMode: '3D',
              zoomEnable: true,
              resizeEnable: true,
              mapStyle: "amap://styles/blue"
            });
            //添加描边
            for (var j = 0; j < bounds.length; j++) {
              new AMap.Polyline({
                path: bounds[j],
                strokeColor: '#00A8FF',
                strokeWeight: 2,
                map: that.map
              })
            }

            var style = [{
              url: that.markerc,
              anchor: new AMap.Pixel(0, 0),
              size: new AMap.Size(16, 16)
            }, {
              url: that.marker,
              anchor: new AMap.Pixel(0, 0),
              size: new AMap.Size(16, 16)
            }];

            var massMarks = new AMap.MassMarks({
              zIndex: 5, // 海量点图层叠加的顺序
              zooms: [3, 25], // 在指定地图缩放级别范围内展示海量点图层
              style: style // 设置样式对象
            }, {
              opacity: 1,
              zIndex: 151,
              cursor: 'pointer',
              style: style
            });
            var data = that.serviceData.customer_record_all.map((item, index) => {
              return {
                lnglat: [item.customer_current_address_longitude, item.customer_current_address_latitude],
                item: item,
                id: index + 1,
                style: 0
              }
            })
            var data1 = that.serviceData.service_log_ing.map((item, index) => {
              return {
                lnglat: [item.sign_longitude, item.sign_latitude],
                item: item,
                id: index + 10001,
                style: 1
              }
            })
            // data1 = [{
            //   lnglat: ['106.53260199676514', '29.359247526071027'],
            //   item: {
            //     customer_age: 36,
            //     customer_current_address: "重庆市九龙坡区中梁山街道腾讯双创社区(重庆)·华岩园区",
            //     customer_id: 5016,
            //     customer_name: "刘飒飒",
            //     customer_phone: "03370799096",
            //     customer_photo_path: "http://resource.yiosi.cn/ks_community/app/service/202206/16/1655370461_azGruhrUQX.jpg",
            //     customer_sex: 1,
            //     nurse_avatar: "",
            //     nurse_name: "蔡海峰",
            //     nurse_phone: "13370799099",
            //     sign_address: "重庆市九龙坡区起西路64号靠近汤念软装窗帘墙布",
            //     sign_area_code: 500102,
            //     sign_latitude: "29.34009517717832",
            //     sign_longitude: "106.24438254486084",
            //   },
            //   id: 10001,
            //   style: 1

            // }]

            function addCustomerMarker(data) {
              // 服务对象分布
              var marker = new AMap.Marker({
                icon: that.markerc,
                position: data.lnglat,
                offset: new AMap.Pixel(0, 0),
              })
              marker.setMap(that.map);
              var item = data.item;
              var title = '',
                content = [],
                content1 = [],
                customer_name = '';
              customer_name = "服务对象：" + item.customer_name
              content.push('性别：' + (item.customer_sex == 1 ? '男 ' : '女 '));
              content.push('年龄：' + item.customer_age + "岁 ");
              content.push('电话：' + item.customer_phone);
              content.push('住址：' + item.customer_current_address);

              var infoWindow = new AMap.InfoWindow({
                isCustom: true,
                content: that.createInfoWindow(title, content.join(
                    "<br/>"), content1.join("<br/>"), customer_name, '', item.customer_photo_path,
                  false),
                offset: new AMap.Pixel(28, 0)
              });
              marker.on('mouseover', (e) => {
                marker.setIcon(that.marker_active);
                infoWindow.open(that.map, marker.getPosition());
              });
              marker.on('mouseout', (e) => {
                marker.setIcon(that.markerc);
                infoWindow.close();
              });
            }

            function addCustomerMarker1(data) {
              // 服务对象分布
              var marker = new AMap.Marker({
                icon: that.marker,
                position: data.lnglat,
                offset: new AMap.Pixel(0, 0),
              })
              marker.setMap(that.map);
              var item = data.item;
              var title = '',
                content = [],
                content1 = [],
                customer_name = '';
              customer_name = "服务对象：" + item.customer_name
              content.push('性别：' + (item.customer_sex == 1 ? '男 ' : '女 '));
              content.push('年龄：' + item.customer_age + "岁 ");
              content.push('电话：' + item.customer_phone);
              content.push('住址：' + item.customer_current_address);

              var nurse_name = "社工：" + item.nurse_name
              content1.push('电话：' + item.nurse_phone);
              content1.push("签到地址：" + item.sign_address);

              var infoWindow = new AMap.InfoWindow({
                isCustom: true,
                content: that.createInfoWindow(title, content.join(
                    "<br/>"), content1.join("<br/>"), customer_name, nurse_name, item
                  .customer_photo_path, true, item.nurse_avatar),
                offset: new AMap.Pixel(28, 0)
              });
              marker.on('mouseover', (e) => {
                marker.setIcon(that.marker_active);
                infoWindow.open(that.map, marker.getPosition());
              });
              marker.on('mouseout', (e) => {
                marker.setIcon(that.marker);
                infoWindow.close();
              });
            }
            massMarks.on('mouseover', function(e) {
              if(e.data.style == 0){
                addCustomerMarker(e.data)
              }else{
                addCustomerMarker1(e.data)
              }
            });

            massMarks.setData([...data, ...data1]);
            massMarks.setMap(that.map);
          })
        }).catch(e => {
          console.log(e);
        })
      },
      createInfoWindow(title, content, content1, customer_name, nurse_name, customer_photo_path, showNurse,
        nurse_avatarUrl) {
        // 顶层盒子
        var info = document.createElement("div");
        info.className = "customer_info_box";
        info.style.width = "434px";

        // 服务对象信息盒子
        var customer_top = document.createElement("div");
        customer_top.className = "customer_top";
        info.appendChild(customer_top);

        // 左侧的信息盒子
        var customer_top_1 = document.createElement("div");
        customer_top_1.className = "customer_top_1";
        customer_top.appendChild(customer_top_1);
        // 左侧的标题背景图片
        var titleBg = document.createElement("img");
        titleBg.className = "titleBg";
        titleBg.src = that.titleBg;
        customer_top_1.appendChild(titleBg);
        // 左侧的标题
        var name = document.createElement("div");
        name.className = "customer_name";
        name.innerHTML = customer_name;
        customer_top_1.appendChild(name);
        // 左侧的服务对象信息
        var top = document.createElement("div");
        top.className = "customer_content";
        top.innerHTML = content;
        customer_top_1.appendChild(top);


        // 右侧的头像
        if (customer_photo_path) {
          var customer_avatar_box = document.createElement("div");
          customer_avatar_box.className = "customer_avatar_box";
          customer_top.appendChild(customer_avatar_box);
          var customer_avatar = document.createElement("img");
          customer_avatar.className = "customer_avatar";
          customer_avatar.src = customer_photo_path + '?imageMogr2/thumbnail/100x'
          customer_avatar_box.appendChild(customer_avatar);
        }


        // 社工信息盒子
        if (showNurse) {
          var nurse_bottom = document.createElement("div");
          nurse_bottom.className = "customer_bottom";
          info.appendChild(nurse_bottom);

          // 左侧的信息盒子
          var nurse_bottom_1 = document.createElement("div");
          nurse_bottom_1.className = "customer_top_1";
          nurse_bottom.appendChild(nurse_bottom_1);
          // 左侧的标题背景图片
          var titleBg1 = document.createElement("img");
          titleBg1.className = "titleBg";
          titleBg1.src = that.titleBg;
          nurse_bottom_1.appendChild(titleBg1);
          // 左侧的标题
          var name1 = document.createElement("div");
          name1.className = "customer_name";
          name1.innerHTML = nurse_name;
          nurse_bottom_1.appendChild(name1);
          // 左侧的社工信息
          var bottom = document.createElement("div");
          bottom.className = "customer_content";
          bottom.innerHTML = content1;
          nurse_bottom_1.appendChild(bottom);

          // 右侧的头像
          if (nurse_avatarUrl) {
            var nurse_avatar_box = document.createElement("div");
            nurse_avatar_box.className = "customer_avatar_box";
            nurse_bottom.appendChild(nurse_avatar_box);

            var nurse_avatar = document.createElement("img");
            nurse_avatar.className = "customer_avatar";
            nurse_avatar.src = nurse_avatarUrl + '?imageMogr2/thumbnail/100x'
            nurse_avatar_box.appendChild(nurse_avatar);
          }

        }
        return info;
      },
      initData() {
        userInfoAPI.serviceStatistics().then(({
          data
        }) => { //服务统计
          if (data.code == 0) {
            that.serviceData = data.data
            that.initGaoDeMap()
          } else {
            that.$message({
              showClose: true,
              message: data.msg,
              type: 'error'
            });
          }
        }).catch((err) => {});

        userInfoAPI.customerInfoStatistics().then(({
          data
        }) => {
          if (data.code == 0) {
            myChart2 = echarts.init(document.getElementById('frame-right1-echarts'));
            const dataList = data.data.map(item => {
              for (var key in item) {
                return item[key]
              }
            })
            const sideData = dataList.map(item => item + 4.5)
            myChart2.setOption({
              title: {
                show: false,
                text: '年龄',
                textStyle: {
                  color: '#ffffff',
                  fontSize: 14
                }
              },
              color: ['#1E9DFF', '#F7B70F', '#016AFF', '#A1E6B6', '#12D7DE'],
              tooltip: {
                trigger: 'axis',
                axisPointer: {
                  type: 'shadow'
                },
                show: false
              },
              legend: {
                show: false
              },
              grid: {
                top: 30,
                left: 0,
                right: 20,
                bottom: 10,
                containLabel: true
              },
              xAxis: {
                type: 'category',
                axisTick: {
                  show: true
                },
                axisLabel: {
                  show: true,
                  color: '#ffffff',
                  fontSize: 8,
                  hideOverlap: false
                },
                splitLine: {
                  show: false
                },
                axisLine: {
                  show: true
                },
                boundaryGap: [0, 0.01],
                data: data.data.map(i => {
                  return Object.getOwnPropertyNames(i) + '岁'
                })
              },
              yAxis: {
                type: 'value',
                axisTick: {
                  show: false
                },
                axisLine: {
                  show: false
                },
                axisLabel: {
                  show: true,
                  color: '#ffffff'
                },
                splitLine: {
                  lineStyle: {
                    color: 'rgba(255,255,255,0.4)',
                    type: 'dashed'
                  }
                }
              },
              // series: [{
              //   name: '人数',
              //   type: 'bar',
              //   data: dataList
              // }],


              series: [{
                name: 'a',
                tooltip: {
                  show: false
                },
                type: 'bar',
                barWidth: 16,
                itemStyle: {
                  normal: {
                    color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                      offset: 0,
                      color: "#0B4EC3" // 0% 处的颜色
                    }, {
                      offset: 0.6,
                      color: "#138CEB" // 60% 处的颜色
                    }, {
                      offset: 1,
                      color: "#17AAFE" // 100% 处的颜色
                    }], false)
                  }
                },
                data: dataList,
                barGap: 0
              }, {
                type: 'bar',
                barWidth: 16,
                itemStyle: {
                  normal: {
                    color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                      offset: 0,
                      color: "#09337C" // 0% 处的颜色
                    }, {
                      offset: 0.6,
                      color: "#0761C0" // 60% 处的颜色
                    }, {
                      offset: 1,
                      color: "#0575DE" // 100% 处的颜色
                    }], false)
                  }
                },
                barGap: 0,
                data: sideData
              }, {
                name: 'b',
                tooltip: {
                  show: false
                },
                type: 'pictorialBar',
                itemStyle: {
                  borderWidth: 1,
                  borderColor: '#0571D5',
                  color: '#2df1ff'
                },
                symbol: 'path://M 0,0 l 90,0 l -60,60 l -90,0 z',
                symbolSize: ['30', '12'],
                symbolOffset: ['0', '-8'],
                symbolRotate: -20,
                symbolPosition: 'end',
                data: dataList,
                z: 3,
                label: {
                  show: true,
                  position: 'top',
                  fontFamily: 'Impact',
                  color: '#2df1ff'
                },
              }]
            })
          } else {
            that.$message({
              showClose: true,
              message: data.msg,
              type: 'error'
            });
          }
        }).catch((err) => {});

        that.getServiceProjectStatistics()
        that.getCustomerServiceStatistics()
        that.getServiceCommentStatistics()
      },
      getServiceProjectStatistics() { // 服务项目统计（扇形图）
        userInfoAPI.serviceProjectStatistics({
          year: ''
        }).then(({
          data
        }) => {
          if (data.code == 0) {
            // 绘制图表
            let data2 = []
            for (var key in data.data) {
              data2.push({
                value: data.data[key],
                name: key
              })
            }
            myChart = echarts.init(document.getElementById('frame-0-echarts'));
            myChart.setOption({
              title: {
                show: false,
                text: '',
                subtext: 'Fake Data',
                left: 'center'
              },
              tooltip: {
                trigger: 'item',
                formatter: '{a} <br/>{b} : {c} ({d}%)'
              },
              color: ['#1E9DFF', '#F7B70F', '#016AFF', '#A1E6B6', '#12D7DE'],
              legend: {
                left: 'center',
                top: 'bottom',
                show: false
              },
              toolbox: {
                show: false,
                feature: {
                  mark: {
                    show: true
                  },
                  dataView: {
                    show: true,
                    readOnly: false
                  },
                  restore: {
                    show: true
                  },
                  saveAsImage: {
                    show: true
                  }
                }
              },
              series: [{
                name: '项目',
                type: 'pie',
                radius: [30, 100],
                center: ['50%', '50%'],
                roseType: 'area',
                itemStyle: {
                  borderRadius: 3
                },
                data: data2
              }]
            });
          } else {
            that.$message({
              showClose: true,
              message: data.msg,
              type: 'error'
            });
          }
        }).catch((err) => {});
      },
      getCustomerServiceStatistics() { // 服务对象服务统计（柱状图）
        userInfoAPI.customerServiceStatistics({
          year: ''
        }).then(({
          data
        }) => {
          if (data.code == 0) {
            myChart1 = echarts.init(document.getElementById('frame-1-echarts'));
            myChart1.setOption({
              grid: {
                x: 55,
                y: 20,
                x2: 10,
                y2: 40
              },
              yAxis: {
                type: 'value',
                nameTextStyle: {
                  color: '#ffffff'
                },
                axisLabel: {
                  color: '#ffffff'
                },
                axisLine: {
                  show: false
                },
                axisTick: {
                  show: false
                },
                splitLine: {
                  show: false
                },
              },
              tooltip: {
                show: true,
                trigger: 'axis',
                axisPointer: {
                  type: 'shadow'
                }
              },

              xAxis: {
                show: true,
                type: 'category',
                axisLabel: {
                  show: true,
                  color: '#ffffff',
                  verticalAlign: 'top'
                },
                axisLine: {
                  show: false
                },
                axisTick: {
                  show: false
                },
                splitLine: {
                  show: false
                },
                data: data.data.map(i => {
                  return Object.getOwnPropertyNames(i) + '月'
                })
              },
              series: [{
                itemStyle: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: '#18E0DD'
                    },
                    {
                      offset: 0.5,
                      color: '#12B5E5'
                    },
                    {
                      offset: 1,
                      color: '#0E94EB'
                    }
                  ])
                },
                data: data.data.map(item => {
                  for (var key in item) {
                    return item[key]
                  }
                }),
                type: 'line',
                showSymbol: false,
                showBackground: true,
                backgroundStyle: {
                  color: 'rgba(180, 180, 180, 0)'
                },
                smooth: true
              }]
            })
          } else {
            that.$message({
              showClose: true,
              message: data.msg,
              type: 'error'
            });
          }
        }).catch((err) => {});
      },
      getServiceCommentStatistics() { // 服务评价统计（折线图）
        userInfoAPI.serviceCommentStatistics().then(({
          data
        }) => {
          if (data.code == 0) {
            this.commentList = data.data.map(item => {
              for (var key in item) {
                return {
                  name: key + '星',
                  value: item[key]
                }
              }
            }).reverse()
            // this.commentList = data.data.map(item => {
            //   for (var key in item) {
            //     return item[key]
            //   }
            // })
            //         myChart3 = echarts.init(document.getElementById('frame-right2-echarts'));
            //         myChart3.setOption({
            //           grid: {
            //             x: 40,
            //             y: 10,
            //             x2: 0,
            //             y2: 10
            //           },
            //           title: {
            //             show: false,
            //             text: '评价数量',
            //             textStyle: {
            //               color: '#ffffff',
            //               fontSize: 14
            //             }
            //           },
            //           tooltip: {
            //             show: true,
            //             trigger: 'axis',
            //           },
            //           color: ['#006CFF'],
            //           yAxis: {
            //             type: 'category',
            //             axisLabel: {
            //               show: true,
            //               color: '#ffffff'
            //             },
            //             axisTick: {
            //               show: false
            //             },
            //             splitLine: {
            //               show: false
            //             },

            //             axisLine: {
            //               show: false
            //             },

            //             data: data.data.map(i => {
            //               return Object.getOwnPropertyNames(i) + '星'
            //             })
            //           },
            //           xAxis: {
            //             type: 'value',
            //             axisLine: {
            //               show: false
            //             },
            //             axisLabel: {
            //               show: false,
            //               color: '#ffffff'
            //             },
            //             axisTick: {
            //               show: false
            //             },
            //             splitLine: {
            //               show: false
            //             },
            //           },
            //           series: [{
            //             data: data.data.map(item => {
            //               for (var key in item) {
            //                 return item[key]
            //               }
            //             }),
            //             type: 'bar',
            //             smooth: true
            //           }]
            //         })
          } else {
            that.$message({
              showClose: true,
              message: data.msg,
              type: 'error'
            });
          }
        }).catch((err) => {});
      }
    },
  }
</script>
<style lang='scss' scoped>
  .borx {
    width: 100vw;
    height: 100vh;
    background-color: #05132C;
    border: 1px solid #05132C;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  .home {
    width: 100%;
    height: 100%;
    /* background-image: url('../../assets/home/back1.png');
    background-size: cover; */
    position: relative;


    .home-head {
      width: 100%;
      position: relative;

      .head-bg {
        display: block;
        width: 100%;
        height: auto;
      }

      .signout {
        i {
          font-size: 24px;
          color: #fff;
        }

        position: absolute;
        top: 20px;
        right: 20px;
      }

      .home-head-text {
        margin-bottom: 10px;
        position: absolute;
        top: 32px;
        left: 50%;
        transform: translateX(-50%);
        font-size: 24px;
        letter-spacing: 4px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #FFFFFF;
        text-shadow: -3px 3px 2px rgba(5, 25, 32, 0.28);
      }

      .timeStamp {
        position: absolute;
        top: 12px;
        left: 15px;
        font-size: 13px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
        text-shadow: -3px 3px 2px rgba(5, 25, 32, 0.28);
        letter-spacing: 2px;
      }
    }

    .home-content {
      width: 100%;
      position: relative;
      padding: 3px 13px 8px;

      .home-Left {
        width: 465px;

        .home-Left0 {
          width: 100%;
          height: 50%;
          flex: 1;
          margin-bottom: 13px;
          position: relative;

          .new-list {
            width: 100%;
            bottom: 10px;
            z-index: 10;
            position: absolute;
            top: 60px;
            left: 0;
            padding: 0 10px;
            overflow-y: hidden;
          }

          /*里面的代码可以根据自己需求去进行更改*/
          /* 设置滚动条的样式 */
          ::-webkit-scrollbar {
            width: 5px;
          }

          /* 滚动槽 */
          ::-webkit-scrollbar-track {
            -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0);
            border-radius: 10px;
          }

          /* 滚动条滑块 */
          ::-webkit-scrollbar-thumb {
            border-radius: 10px;
            background: #054C99;
            -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0);
          }

          ::-webkit-scrollbar-thumb:window-inactive {
            background: #044B97;
          }

        }

        .home-Left1 {
          width: 100%;
          height: 50%;
          flex: 1;
          position: relative;

          .frame-1 {
            width: 100%;
            height: calc(100% - 59px);
            position: absolute;
            top: 60px;
            left: 0;
            z-index: 10;
          }
        }
      }

      .home-in {
        width: 100%;
        height: 100%;
        overflow: hidden;
        padding: 0 13px;

        .home-in-top {
          width: 100%;
          height: 100px;
          background: rgba(0, 123, 245, 0.26);
          border: 2px solid #2CB1FF;
          text-align: center;
          position: relative;

          .border-bottom {
            width: 456px;
            height: 24px;
            position: absolute;
            bottom: -13px;
            right: -100px;
          }

          .border-top {
            width: 456px;
            height: 24px;
            position: absolute;
            top: -15px;
            left: -120px;
          }

          .num {
            font-size: 24px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #00A8FF;
            line-height: 32px;
            margin-bottom: 5px;
          }

          .name {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #BFDEFD;
          }
        }

        .home-in-bottom {
          width: 100%;
          flex: 1;
          margin-top: 13px;
          border: 2px solid #0289CF;
          position: relative;

          &:before {
            content: '';
            width: 100%;
            position: absolute;
            left: 0;
            right: 0;
            bottom: -3px;
            border-bottom: inherit;
            z-index: 14;
          }

          .home-in-chart {
            width: 100%;
            height: calc(100% + 24px);
            /* position: a; */
            z-index: 13;
          }

          .service-count {
            top: 20px;
            left: 20px;
            position: absolute;
            z-index: 14;

            .flex-fs {
              margin-bottom: 15px;
            }

            .tag {
              width: 18px;
              height: 12px;
              background: #007BF3;
              margin-right: 8px;
            }

            .tag-name {
              font-size: 12px;
              font-weight: 400;
              color: #FFFFFF;
              opacity: 0.46;
            }
          }
        }
      }

      .home-right {
        width: 465px;
        height: 100%;

        .home-right1 {
          width: 100%;
          flex: 1;
          margin-bottom: 13px;
          position: relative;

          .frame-1 {
            width: 100%;
            height: calc(100% - 50px);
            position: absolute;
            top: 54px;
            left: 3%;
            z-index: 10;
          }
        }

        .home-right2 {
          width: 100%;
          height: 55%;
          position: relative;

          .frame-2 {
            width: 100%;
            height: calc(100% - 50px);
            position: absolute;
            top: 54px;
            left: 0;
            z-index: 10;

            .count-box {
              height: 180px;
              width: 100%;
              background: url('../../assets/home/comment-bg.png') no-repeat;
              background-size: auto 100%;
              padding-left: 25px;

              .box {
                width: 170px;
                text-align: center;
              }

              .n {
                font-size: 30px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #FFFFFF;
                padding: 5px 0;
                white-space: nowrap;
              }

              p {
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                letter-spacing: 2px;
                color: #FFFFFF;
                padding-left: 50px;
              }

              .u {
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 18px;
              }
            }

            .star-box {
              width: 100%;
              padding: 10px 0 0 25px;

              .flex-fs {
                margin-bottom: 20px;

                span {
                  color: #fff;
                  font-size: 14px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #FFFFFF;
                  padding: 0 20px 0 10px;
                }

                a {
                  width: 70px;
                  font-size: 14px;
                  font-family: Adobe Heiti Std;
                  font-weight: normal;
                  color: #FFFFFF;
                  padding-left: 15px;
                  opacity: 0.8;
                  white-space: nowrap;
                }
              }
              /deep/ .el-progress-bar__outer{
                background-color: #0A337E;
              }
            }
          }
        }
      }
    }


    .home-Tips {
      width: 516px;
      height: 33px;
      position: absolute;
      top: 50px;
      left: 0;
      bottom: 0;
      right: 0;
      margin: 0 auto;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
</style>
